<template>
  <div  v-redirect-if-no-permission:PHONE_BOOKING class="main-container">
    <div class="elements-container" style="max-width: 1248px">
      <div class="order-form shadow">
        <div class="form">
          <div>
            <v-layout>
              <v-flex xs6>
                <h1>{{ pageType === "Edit Order" ? $t("dispatching.phoneBooking.editOrder") : $t("dispatching.phoneBooking.newOrder") }}</h1>
                <h2>{{ $t("dispatching.phoneBooking.subtitle") }}</h2>
              </v-flex>
              <v-flex xs6>
                <button style="margin-top: 0px;" @click="declined_order_dialog = true"> {{ $t("dispatching.phoneBooking.newDeclinedOrder") }}</button>
              </v-flex>
            </v-layout>

          </div>
          <div class="input">
            <label :class="[modelErrors.passenger_number && 'text-red']">{{ $t("dispatching.phoneBooking.passengerNumber") }}
              <span v-if="modelErrors.passenger_number">{{ $t("dispatching.phoneBooking.invalidPhoneNumber") }}</span></label>
            <PassengersAutoComplete ref="passengersAutoComplete" class="w-full" placeholder="+33 00 00 00 00" @input="
              model.passenger_name = $event.full_name;
            model.no_whatsapp = $event.no_whatsapp;
            model.vip = $event.vip;
            if (['en', 'fr', 'it'].includes($event.language)) {
              model.passenger_language = $event.language;
            } else {
              model.passenger_language = 'fr';
            }
       
            model.passenger_number = $event.phone_number || $event.username;
            model['passenger_id'] = $event.id;
            nameDisabled = true;
            " :disableAutocomplete="model['passenger_id']" :disabled="numberDisabled"
              @validate="validateAt(['passenger_name', 'passenger_number'])" @setName="
                model.passenger_number = $event;
              model.passenger_name = '';
              model['passenger_id'] = null;
              nameDisabled = false;
              " :value="model.passenger_number" :error="modelErrors.passenger_number" />
            
          </div>
          <div v-show="!bookingStatus || !model.passenger_id" class="input">
            <button
              style="margin-top: 0px; background: none; border: none; padding: 0; color: #1976d2;  cursor: pointer"
              :disabled="requestingLocation" @click="requestPassengerLocation()">
              {{ requestingLocation ? $t("dispatching.phoneBooking.loading") : $t("dispatching.phoneBooking.requestLocation") }}
            </button>
            <div class="pass-container">
              <div class="pass-left check-box">
                <input type="checkbox" v-model="model.no_whatsapp" :disabled="!model.passenger_id" />
                <label class="noselect" @click="true">{{ $t("dispatching.phoneBooking.noWhatsapp") }}</label>
                <input type="checkbox" v-model="model.vip" style="margin-left: 12px;" :disabled="!model.passenger_id" />
                <label class="noselect" @click="true">VIP</label>
              </div>
              <div class="pass-right input">
                <RadioGroup :options="passenger_languages" @input="
                  model.passenger_language = $event.value;
                modelErrors.passenger_language = false;
                " :value="findLanguageByValue(model.passenger_language)" />
              </div>
            </div>
            
          </div>
          <div class="input">
            <label :class="[modelErrors.passenger_name && 'text-red']">{{ $t("dispatching.phoneBooking.passengerFullName") }}
              <span v-if="modelErrors.passenger_name">{{ $t("dispatching.phoneBooking.invalidPassengerName") }}</span></label>
            <input type="text" v-model="model.passenger_name" :disabled="nameDisabled"
              @blur="validateAt(['passenger_name', 'passenger_number'])"
              :class="[modelErrors.passenger_name && 'border-red']" :placeholder="$t('dispatching.phoneBooking.enterPassengerName')" />
          </div>
          <div class="input">
            <label class="text-gray">{{ $t("dispatching.phoneBooking.datetime") }}</label>
            <TimeSelectInput @input="selectedTime = $event" :value="selectedTime" />
          </div>
          <div class="input">
            <label :class="[modelErrors.pick_up_location && 'text-red']">{{ $t("dispatching.phoneBooking.pickup") }}
              <span v-if="
                modelErrors.pick_up_location || modelErrors.pick_up_location_details
              ">{{ $t("dispatching.phoneBooking.invalidPickup") }}</span></label>
            <GoogleMapsInput class="w-full" :placeholder="$t('dispatching.phoneBooking.selectPickup')" @input="selectPickUp($event)"
              @validate="validateAt(['pick_up_location', 'pick_up_location_details'])" :value="pickUpLocationObj"
              :passenger_id="model.passenger_id" :error="modelErrors.pick_up_location || modelErrors.pick_up_location_details
                " />
          </div>

          <div class="input">
            <label :class="[
              (modelErrors.pull_down_location ||
                modelErrors.pull_down_location_details) &&
              'text-red',
            ]">{{ $t("dispatching.phoneBooking.selectCity") }}
              <span v-if="
                modelErrors.pull_down_location || modelErrors.pull_down_location_details
              ">{{ $t("dispatching.phoneBooking.invalidCity") }}</span></label>
            <SelectInput :options="clusters" :show_label_flag="show_label" :select_obj="true" @input="
              selectPullDown($event);
            getEstimatedPrice();
            " @validate="validateAt(['pull_down_location', 'pull_down_location_details'])" :value="pulldownLocationObj"
              :error="modelErrors.pull_down_location || modelErrors.pull_down_location_details
                " :onlyShow="false" :placeholder="$t('dispatching.phoneBooking.selectDestination')" />
          </div>
          <div class="input" v-if="
            (model.city && model.city.title === 'Monaco') ||
            // ('time' in model && model.time != 'ASAP') ||
            ($route.query.show_order_list === 'false' &&
              pulldownLocationObj.title === 'Monaco')
          ">
            <label :class="[modelErrors.pull_down_location_details && 'text-red']">{{ $t("dispatching.phoneBooking.destinationDetails") }}
              <span v-if="modelErrors.pull_down_location_details">{{ $t("dispatching.phoneBooking.invalidDestination") }}</span></label>
            <GoogleMapsInput class="w-full" :placeholder="$t('dispatching.phoneBooking.selectDestination')" @input="
              model.pull_down_location_details = $event.formatted_address;
            model.pull_down_location.coordinates = [
              $event.geometry.coordinates[0],
              $event.geometry.coordinates[1],
            ];
            model.landmark_dropoff = $event.name || $event.street_name;
            " @validate="validateAt(['pull_down_location_details'])" :value="pulldownLocationObj"
              :passenger_id="model.passenger_id" :error="modelErrors.pull_down_location_details" />
          </div>
          <div class="input">
            <label class="text-gray">{{ $t("dispatching.phoneBooking.comments") }}</label>
            <input name="comments" type="text" autocomplete="off" v-model="model.notes" :placeholder="$t('dispatching.phoneBooking.enterComments')" />
          </div>

          <div class="input">
            <label :class="modelErrors.vehicle_type_id ? 'text-primary-color' : 'text-gray'">{{ $t("dispatching.phoneBooking.carType") }}
              <span v-if="modelErrors.vehicle_type_id">{{ $t("dispatching.phoneBooking.selectVehicleType") }}</span></label>
            <RadioGroup :options="cars" :value="selectedCar" @input="
              model.vehicle_type_id = $event.id;
            selectedCar = $event;
            " />
          </div>
          <div class="input">
            <label :class="modelErrors.seats ? 'text-primary-color' : 'text-gray'">{{ $t("dispatching.phoneBooking.numberOfSeats") }}
              <span v-if="modelErrors.seats">{{ $t("dispatching.phoneBooking.selectNumberOfSeats") }}</span></label>
            <RadioGroup :rounded="true" :options="seat_numbers" :value="{ title: model.seats }" @input="
              model.seats = $event.title;
            modelErrors.seats = false;
            " />
          </div>
          <div class="input">
            <label :class="modelErrors.number_of_baggages ? 'text-primary-color' : 'text-gray'">{{ $t("dispatching.phoneBooking.numberOfBags") }}
              <span v-if="modelErrors.number_of_baggages">{{ $t("dispatching.phoneBooking.selectNumberOfBaggages") }}</span></label>
            <RadioGroup :rounded="true" :options="baggages_number" :value="{ title: model.number_of_baggages }" @input="
              model.number_of_baggages = $event.title;
            modelErrors.number_of_baggages = false;
            " />
          </div>

          <!--<div class="input">
            <label :class="modelErrors.languages ? 'text-primary-color' : 'text-gray'">Languages
              <span v-if="modelErrors.languages">Please select number of baggages</span></label>
            <CheckBoxesGroup :options="languages" @input="
              model.languages = [];
            model.languages = $event;
            modelErrors.languages = false;
            " :value="model.languages" />
          </div>-->
          <div class="input">
            <label class="text-gray">{{ $t("dispatching.phoneBooking.constraints") }}</label>
            <CheckBoxesGroup :options="constraints" @input="selectedConstraints = $event"
              :value="selectedConstraints" />
          </div>
          <div class="input">
            <label class="text-gray">{{ $t("dispatching.phoneBooking.priorityOrder") }}</label>
            <div class="check-box">
              <input type="checkbox" v-model="model.high_priority" />
              <label class="noselect" @click="model.high_priority = !model.high_priority">{{ $t("dispatching.phoneBooking.markAsPriority") }}</label>
            </div>
          </div>
          <div class="input" v-show="REPLACE_CAR_SERVICE_IDS.includes(model.vehicle_type_id)">
            <label class="text-gray">{{ $t("dispatching.phoneBooking.redispatchVanOrders") }}</label>
            <div class="check-box">
              <input type="checkbox" v-model="redispatch_van_orders" />
              <label class="noselect" @click="redispatch_van_orders = !redispatch_van_orders">{{ $t("dispatching.phoneBooking.replaceWithTwoCars") }}</label>
            </div>
          </div>
          <div class="input">
            <label class="text-gray">{{ $t("dispatching.phoneBooking.multipleOrders") }}</label>
            <div class="check-box">
              <input type="checkbox" v-model="showMultipleOrdersInput" />
              <label class="noselect" @click="showMultipleOrdersInput = !showMultipleOrdersInput">{{ $t("dispatching.phoneBooking.sendMultipleOrders") }}</label>
            </div>
            <input type="text" style="margin-top: 8px" v-model="multipleOrdersCount" v-if="showMultipleOrdersInput" />
          </div>
          <!-- <div class="input">
            <label>{{ $t("dispatching.phoneBooking.payment") }}</label>
            <RadioGroup
              :options="paymentMethods"
              @input="selectedPaymentMethod = $event"
            />
          </div> -->
          <!-- @click="sendRequest" -->
          <div class="w-full float-left">
            <button class="btn" :loading="loading" style="float: left" v-if="
              ['PENDING', 'APPROVED', 'ACCEPTED', 'STARTED', 'ARRIVED'].includes(
                bookingStatus
              ) && !isEmpty(this.modifiedModel)
            " @click="UpdateBooking()">
              {{ $t("dispatching.phoneBooking.editOrder") }}
            </button>
            <button class="btn" @click="sendCreateBookingReq()" :disabled="sendingRequest"
              v-if="($route.query.show_order_list || true) == true">
              {{ sendingRequest ? $t("dispatching.phoneBooking.loading") : $t("dispatching.phoneBooking.send") }}
            </button>
            <button class="btn" style="float: right" v-if="
              [
                'DONE',
                'PAID',
                'PICKED_UP',
                'PENDING',
                'APPROVED',
                'ACCEPTED',
                'STARTED',
                'ARRIVED',
              ].includes(bookingStatus) && isEmpty(this.modifiedModel)
            " :disabled="sendingRequest" @click="sendCreateBookingReq()">
              {{ sendingRequest ? $t("dispatching.phoneBooking.loading") : $t("dispatching.phoneBooking.duplicate") }}
            </button>

            <span v-if="estimatedPrice" style="color: #788e98; float: left; margin-top: 8%">{{ $t("dispatching.phoneBooking.estimatedPrice", { price: estimatedPrice }) }}€</span>
          </div>
        </div>
      </div>
      <!-- TWAL -->
      <div class="right-bar" v-if="($route.query.show_order_list || true) == true">
        <div class="drivers-count shadow" ref="counts">
          <div class="item shadow" v-for="(item, i) in items" @mouseenter="fixScroll(i)" :id="i" :key="i">
            <div class="item-container">
              <div class="item-content">
                <h2>{{ item.title }}</h2>
                <label>{{ item.count }}</label>
              </div>
              <div class="vehicle-counts">
                <div v-for="(count, j) in item.vehicleCounts" :key="j">
                  <label>{{ count.name }}</label><br />
                  <label style="margin-left: 2px">{{ count.count }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="message" v-if="items.length == 0">{{ $t("dispatching.phoneBooking.noAvailableDrivers") }}</div>
        </div>
        <div class="client-orders shadow">
          <p style="width: 100%; text-align: center; margin-bottom: 0">
            {{ $t("dispatching.phoneBooking.passengerOrders") }}
          </p>
          <InfinityScroll v-if="model.passenger_id" :passengerId="model.passenger_id" time="BOTH" maxHeight="375"
            :showStatusPerCard="true" />
          <p v-else style="width: 100%; color: #7e939c; text-align: center; margin-bottom: 0">
            {{ $t("dispatching.phoneBooking.selectPassengerToShowOrders") }}
          </p>
        </div>
      </div>
    </div>

    <v-dialog v-model="declined_order_dialog" max-width="800">
      <v-card>
        <v-container>
          <v-form :key="declined_form_key" ref="declined_order_form">
            <v-card-title>
              <span class="headline">{{ $t("dispatching.phoneBooking.addDeclinedOrder") }}</span>
            </v-card-title>
            <div>

              <v-autocomplete v-model="declined_city" :rules="[required]" :items="clusters" item-text="title"
                item-value="id" :label="$t('dispatching.phoneBooking.selectCity')"></v-autocomplete>

            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="declined_order_dialog = false" :loading="declined_order_loading">{{ $t("common.close") }}</v-btn>
              <v-btn color="primary" @click="addDeclinedBooking" :loading="declined_order_loading">{{ $t("common.save") }}</v-btn>
            </v-card-actions>

          </v-form>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="passengerLocationDialog" max-width="1100px">
      <v-card class="location-card">
        <div class="location-header">
          <div>
            <p class="location-title">{{ $t("dispatching.phoneBooking.passengerLocation") }}</p>
            <p class="location-subtitle">{{ passengerLocationName }}</p>
          </div>
          <button class="location-close-icon" @click="passengerLocationDialog = false">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div class="location-content">
          <div v-if="passengerLocationLandmarks.length" class="landmarks">
            <p class="landmarks-title">{{ $t("dispatching.phoneBooking.nearestLandmarks") }}</p>
            <div
              v-for="landmark of passengerLocationLandmarks"
              :key="landmark.id"
              class="landmark"
              :class="{
                disabled: landmarkPickupLoadingId !== null,
                loading: landmarkPickupLoadingId === landmark.id,
              }"
              @click="selectLandmarkAsPickUp(landmark)"
            >
              <div class="landmark-info">
                <span class="landmark-name">{{ landmark.name }}</span>
                <span v-if="landmark.formatted_address" class="landmark-address">{{
                  landmark.formatted_address
                }}</span>
              </div>
              <span class="landmark-hint">
                {{ landmarkPickupLoadingId === landmark.id ? $t("dispatching.phoneBooking.loading") : $t("dispatching.phoneBooking.setAsPickup") }}
              </span>
            </div>
          </div>
          <div class="location-map">
            <gmap-map
              v-if="passengerLocationMarker"
              :center="passengerLocationMarker"
              :zoom="15"
              :options="passengerLocationMapOptions"
              style="width: 100%; height: 100%"
            >
              <gmap-marker :position="passengerLocationMarker"></gmap-marker>
            </gmap-map>
          </div>
        </div>
        <div class="location-footer">
          <button class="location-close" @click="passengerLocationDialog = false">{{ $t("common.close") }}</button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
let CancelToken = axios.CancelToken;
import * as yup from "yup";
import * as gjv from "geojson-validation";
import socketEventMixin from "@/mixins/socketEventsMixin";
import TimeSelectInput from "@/components/widgets/TimeSelectInput";
import GoogleMapsInput from "@/components/widgets/GoogleMapsInput";
import RadioGroup from "@/components/widgets/RadioGroup";
import SelectInput from "@/components/widgets/SelectInput";
import CheckBoxesGroup from "@/components/widgets/CheckBoxesGroup";
import PassengersAutoComplete from "@/components/widgets/PassengersAutoComplete";
import InfinityScroll from "@/components/dispatching/InfinityScroll";
import { forEach, toInteger, isEmpty } from "lodash";

// modelErrors: {
//   pick_up_location: false,
//   pick_up_location_details: false,
//   pull_down_location: false,
//   pull_down_location_details: false,
//   seats: false,
//   vehicle_type_id: false,
//   number_of_baggages: false,
//   time: false,
//   languages: false,
//   notes: false,
// },

const modelSchema = yup.object().shape({
  pick_up_location: yup
    .object()
    .test("is-geojson", "Not GeoJSON", (value) => gjv.valid(value))
    .required(),
  pull_down_location: yup
    .object()
    .test("is-geojson", "Not GeoJSON", (value) => gjv.valid(value))
    .required(),
  seats: yup.number().required(),
  number_of_baggages: yup.number().required(),
  time: yup.string(),
  languages: yup.array(),
  pick_up_location_details: yup.string().required(),
  pull_down_location_details: yup.string(),
  notes: yup.string(),
  passenger_name: yup.string().required(),
  passenger_number: yup.string().required(),
  vehicle_type_id: yup.string().required(),
});

const editedModelSchema = yup.object().shape({
  pick_up_location: yup.object(),
  pull_down_location: yup.object(),
  seats: yup.number(),
  number_of_baggages: yup.number(),
  time: yup.string(),
  languages: yup.array(),
  pick_up_location_details: yup.string(),
  pull_down_location_details: yup.string(),
  notes: yup.string(),
  passenger_name: yup.string(),
  passenger_number: yup.string(),
  vehicle_type_id: yup.string(),
});

export default {
  name: "PhoneBooking",
  title() {
    return this.$t("dispatching.phoneBooking.title");
  },
  components: {
    TimeSelectInput,
    GoogleMapsInput,
    SelectInput,
    RadioGroup,
    CheckBoxesGroup,
    PassengersAutoComplete,
    InfinityScroll,
  },
  props: ["passenger_id"],
  mixins: [socketEventMixin],
  events() {
    return {
      "Ride:captain_check": this.updateCounts,
      "Timeline:update_passenger_location": this.getPassengerLocation
    };
  },
  data() {
    return {
      pageType: "New Order",
      showMultipleOrdersInput: false,
      closeAfterSubmit: false,
      multipleOrdersCount: 2,
      REPLACE_CAR_SERVICE_IDS: [2, 3, 7], // make sure that VAN8 id is 8 in production
      // VAN_SERVICE_IDS: 2,
      // VAN8_SERVICE_ID: 8, //make sure that VAN8 id is 8 in production
      loading: false,
      // MONO_SERVICE_ID: 3,
      ordertype: "",
      show_order_list: true,
      declined_order_dialog: false,
      declined_order_loading: false,
      declined_city: null,
      declined_form_key:0,
      requestingLocation: false,
      passengerLocationDialog: false,
      passengerLocationMarker: null,
      passengerLocationName: "",
      passengerLocationLandmarks: [],
      landmarkPickupLoadingId: null,
      passengerLocationMapOptions: {
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      },
      bookingStatus: null,
      initmodel: {},
      pickUpLocationObj: {},
      pulldownLocationObj: {},
      nameDisabled: false,
      numberDisabled: false,
      model: {
        service_id: 1,
        passenger: "",
        passenger_id: null,
        passenger_name: "",
        passenger_number: "",
        pick_up_location: {},
        pull_down_location: {},
        pick_up_location_details: "",
        pull_down_location_details: "",
        city: {},
        number_of_baggages: 1,
        seats: 1,
        pets: false,
        low_car: false,
        phone_booking: true,
        landmark_pickup: null,
        landmark_dropoff: null,
        wheelchair: false,
        round_trip: false,
        vehicle_type_id: null,
        time: "ASAP",
        languages: [],
        notes: "",
        landmark: "",
        encompt: false,
        amex: false,
        mad: false,
        test: false,
        high_priority: false,
        dynamic_constraints: [],
        no_whatsapp: 0,
        vip: 0,
        passenger_language: 'fr'
      },
      redispatch_van_orders: false,
      modelErrors: {
        pick_up_location: false,
        pick_up_location_details: false,
        pull_down_location: false,
        pull_down_location_details: false,
        seats: false,
        vehicle_type_id: false,
        number_of_baggages: false,
        time: false,
        languages: false,
        notes: false,
        passenger_name: false,
        passenger_number: false,
      },
      selectedTime: "ASAP",
      cities: [],
      selectedCity: {
        centroid: {},
      },
      items: [
        {
          title: "SV",
          count: 12,
          vehicleCounts: [
            {
              name: "Bus",
              count: 23,
            },
            {
              name: "Car",
              count: 23,
            },
            {
              name: "Van",
              count: 23,
            },
            {
              name: "Monospace",
              count: 23,
            },
            {
              name: "Break",
              count: 23,
            },
          ],
        },
      ],
      cars: [],
      mandatory_details: false,
      seat_numbers: [],
      baggages_number: [],
      clusters: [],
      languages: [],
      passenger_languages: [],
      selectedCar: null,
      selectedCarObj: {},
      constraints: [],
      show_label: true,
      selectedConstraints: [],
      paymentMethods: [],
      selectedPaymentMethod: "",
      sendingRequest: false,
      modifiedModel: {},
      initConstraints: [],
      estimatedPrice: "",
      pick_up_location_point: null,
    };
  },
  methods: {
    
    addDeclinedBooking() {
      if (!this.$refs.declined_order_form.validate()) return;
      if (!this.declined_city){
         window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.chooseCity"), "red");
         return;
      } 
      if (!this.model.passenger_id && !(this.model.passenger_name  && this.model.passenger_number )){
         window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.choosePassenger"), "red");
         return;
      } 
      this.declined_order_loading = true;
      this.axios
        .post(`declined_booking`, {"location_cluster_id":this.declined_city, "passenger_id":this.model.passenger_id, "passenger_name":this.model.passenger_name, "passenger_number":this.model.passenger_number})
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.addedSuccessfully"), "green");
          this.declined_order_dialog = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.declined_order_loading = false;
        });
    },
    requestPassengerLocation() {
      if (!this.model.passenger_id && !(this.model.passenger_name  && this.model.passenger_number )){
         window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.choosePassenger"), "red");
         return;
      } 
      this.requestingLocation = true;
      this.axios
        .post(`passenger/request-location`,{"passenger_id":this.model.passenger_id, "passenger_name":this.model.passenger_name, "passenger_number":this.model.passenger_number})
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.locationRequested"), "green");
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        })
        .finally(() => {
          this.requestingLocation = false;
        });
    },
    findLanguageByValue(value) {
      return this.passenger_languages.find(lang => lang.value === value) || "fr";
    },
    compareTimes(time1, time2) {
      const format = "DD-MM-YYYY HH:mm"; // common format
      const date1 = this.convertDateFormat(time1);
      console.log("date1", date1);
      const date2 = this.convertDateFormat(time2);
      console.log("date2", date2);
      return date1.getTime() === date2.getTime();
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    convertDateFormat(dateString) {
      const match = dateString.match(
        /(\w{3})\s*,\s*(\w{3})\s*(\d{1,2})\s*,\s*(\d{4})\s*at\s*(\d{1,2}):(\d{2})\s*(AM|PM)/i
      );
      if (!match) {
        return null;
      }
      const monthNames = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };
      const month = monthNames[match[2]];
      const day = Number(match[3]);
      const year = Number(match[4]);
      let hours = Number(match[5]);
      const minutes = Number(match[6]);
      const ampm = match[7].toLowerCase();
      if (ampm === "pm" && hours !== 12) {
        hours += 12;
      } else if (ampm === "am" && hours === 12) {
        hours = 0;
      }
      const date = new Date(year, month, day, hours, minutes);
      const formattedDate = this.formatDate(date);
      return formattedDate;
    },
    arraysEqual(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b)) {
        return false;
      }
      if (a === b) return true;
      if (a.length !== b.length) return false;

      // Sort the arrays before comparing
      const sortedA = a.slice().sort();
      const sortedB = b.slice().sort();

      for (let i = 0; i < sortedA.length; i++) {
        if (sortedA[i] !== sortedB[i]) return false;
      }
      return true;
    },
    isEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }
      return true;
    },
    UpdateBooking() {
      editedModelSchema
        .validate(this.modifiedModel)
        .then(() => {
          this.loading = true;
          this.formData();

          // modelSchema
          //   .validate(this.model)
          //   .then(() => {
          // this.sendingRequest = true;
          if (this.modifiedModel.time != null) {
            this.modifiedModel.time = moment(this.modifiedModel.time, "DD-MM-YYYY HH:mm").format("Y-MM-DD HH:mm");
          }
          var id = this.$route.query.id;
          this.axios
            .put(`booking/${id}`, this.modifiedModel)
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.successfullySaved"), "green");
              this.resetModel();
              window.scrollTo(0, 0);
              if (this.$route.query.show_order_list === "false")
                setTimeout(() => window.close(), 1000);
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
            })
            .finally(() => {
              this.sendingRequest = false;
            });
        })
        .catch(() => {
          this.loading = false;
          window.scrollTo(0, 0);
          Object.keys(this.model).forEach((key) => {
            if (key in this.modelErrors) {
              editedModelSchema
                .validateAt(key, this.modifiedModel)
                .then(() => {
                  this.modelErrors[key] = false;
                })
                .catch(() => {
                  console.log("VALIDATION ERROR AT ", key);
                  this.modelErrors[key] = true;
                });
            }
          });
        });
      //   window.scrollTo(0, 0);
      //   Object.keys(this.modifiedModel).forEach((key) => {
      //     if (key in this.modelErrors) {
      //       modelSchema
      //         .validateAt(key, this.modifiedModel)
      //         .then(() => {
      //           this.modelErrors[key] = false;
      //         })
      //         .catch(() => {
      //           console.log("VALIDATION ERROR AT ", key);
      //           this.modelErrors[key] = true;
      //         });
      //     }
      //   });
      // });
    },
    getPassengerLocation(data){
      console.log("getPassengerLocation",data)

      if (data.passenger_id != this.model.passenger_id && data.passenger_phone != this.model.passenger_number ) return;
      this.passengerLocationName = data.passenger_name;
      this.passengerLocationMarker = {
        lat: Number(data.lat),
        lng: Number(data.lng),
      };
      this.passengerLocationLandmarks = data.nearest_landmarks || [];
      this.landmarkPickupLoadingId = null;
      this.passengerLocationDialog = true;
    },
    selectLandmarkAsPickUp(landmark) {
      if (this.landmarkPickupLoadingId !== null) return;
      this.landmarkPickupLoadingId = landmark.id;
      axios
        .get("address", {
          params: {
            address: landmark.name,
            passenger_id: this.model.passenger_id,
          },
        })
        .then((res) => {
          const area = (res.data.data || []).find((item) => item.id === landmark.id);
          if (!area || !area.centroid) {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("dispatching.phoneBooking.landmarkLocationError"),
              "red"
            );
            return;
          }
          const formatted_address =
            landmark.formatted_address ||
            (area.name ? area.name + ", " : "") +
              (area.street_number ? area.street_number + " " : "") +
              (area.street_name ? area.street_name : "");
          this.selectPickUp({
            geometry: area.centroid,
            formatted_address,
            name: area.name,
            street_name: area.street_name,
          });
          this.pickUpLocationObj = {
            name: area.name || area.street_name,
            formatted_address,
          };
          this.validateAt(["pick_up_location", "pick_up_location_details"]);
          this.passengerLocationDialog = false;
        })
        .catch((err) => {
          window.getApp.$emit(
            "SHOW_TOAST",
            (err.response && err.response.data.message) ||
              this.$t("dispatching.phoneBooking.landmarkLocationError"),
            "red"
          );
        })
        .finally(() => {
          this.landmarkPickupLoadingId = null;
        });
    },
    updateCounts(data) {
      if (data.old_state !== data.state) {
        // get the in service index
        let inServiceIndex = this.items.findIndex((item) => {
          return item.title === "SV";
        });
        if (data.old_state === "UNAVAILABLE") {
          if (inServiceIndex >= 0) {
            this.items[inServiceIndex].count++;
            let vehicleIndex = this.items[inServiceIndex].vehicleCounts.findIndex(
              (item) => {
                return item.name.toLowerCase() == data.vehicle_name.toLowerCase();
              }
            );
            if (vehicleIndex >= 0) {
              this.items[inServiceIndex].vehicleCounts[vehicleIndex].count++;
            } else {
              this.items[inServiceIndex].vehicleCounts.push({
                name:
                  data.vehicle_name.charAt(0).toUpperCase() + data.vehicle_name.slice(1),
                count: 1,
              });
            }
          } else {
            this.items.push({
              title: "SV",
              count: 1,
              vehicleCounts: [
                {
                  name:
                    data.vehicle_name.charAt(0).toUpperCase() +
                    data.vehicle_name.slice(1),
                  count: 1,
                },
              ],
            });
          }
        } else if (data.state === "UNAVAILABLE" && inServiceIndex >= 0) {
          this.items[inServiceIndex].count--;
          let vehicleIndex = this.items[inServiceIndex].vehicleCounts.findIndex(
            (item) => {
              return item.name.toLowerCase() == data.vehicle_name.toLowerCase();
            }
          );
          if (vehicleIndex >= 0) {
            this.items[inServiceIndex].vehicleCounts[vehicleIndex].count--;
          }
          if (this.items[inServiceIndex].vehicleCounts[vehicleIndex].count == 0) {
            this.items.splice(inServiceIndex, 1);
          }
        }
        let index = null;
        // increase the count
        if (data.state !== "UNAVAILABLE") {
          index = this.items.findIndex((item) => {
            return item.title === this.getShortcutName(data.state);
          });
          if (index >= 0) {
            this.items[index].count++;
            let vehicleIndex = this.items[index].vehicleCounts.findIndex((item) => {
              return item.name.toLowerCase() == data.vehicle_name.toLowerCase();
            });
            if (vehicleIndex >= 0) {
              this.items[index].vehicleCounts[vehicleIndex].count++;
            } else {
              this.items[index].vehicleCounts.push({
                name:
                  data.vehicle_name.charAt(0).toUpperCase() + data.vehicle_name.slice(1),
                count: 1,
              });
            }
          } else {
            this.items.push({
              title: this.getShortcutName(data.state),
              count: 1,
              vehicleCounts: [
                {
                  name:
                    data.vehicle_name.charAt(0).toUpperCase() +
                    data.vehicle_name.slice(1),
                  count: 1,
                },
              ],
            });
          }
        }
        // decrease the count
        index = this.items.findIndex((item) => {
          return item.title == this.getShortcutName(data.old_state);
        });
        if (index >= 0) {
          this.items[index].count--;
          let vehicleIndex = this.items[index].vehicleCounts.findIndex((item) => {
            return item.name.toLowerCase() == data.vehicle_name.toLowerCase();
          });
          if (vehicleIndex >= 0) {
            this.items[index].vehicleCounts[vehicleIndex].count--;
            if (this.items[index].vehicleCounts[vehicleIndex].count <= 0) {
              this.items[index].vehicleCounts.splice(vehicleIndex, 1);
            }
          }
          if (
            this.items[index].vehicleCounts.length == 0 ||
            this.items[index].count == 0
          ) {
            this.items.splice(index, 1);
          }
        }
        let count = 0;
        this.items.forEach((i) => {
          if (i.title !== "SV") count += i.count;
        });
        let svIndex = this.items.findIndex((item) => {
          return item.title === "SV";
        });
        if (svIndex >= 0 && count != this.items[svIndex].count) {
          this.loadStatusesCounts();
        } else if (svIndex < 0 && count > 0) {
          this.loadStatusesCounts();
        }
      }
    },
    loadClusters() {
      this.axios
        .get("location_cluster?perPage=100")
        .then((res) => {
          this.clusters = [];
          res.data.data.data.forEach((item) => {
            this.clusters.push({
              id: item.id,
              title: item.title,
              centroid: item.centroid,
              type: item.type,
              far_city: item.far_city ? item.far_city : 0,
            });
          });
        })
        .catch((err) => console.error(err));
    },
    loadVehicleTypes() {
      this.axios
        .get("vehicle_type?perPage=100")
        .then((res) => {
          this.cars = [];
          res.data.data.data.forEach((item) => {
            this.cars.push({
              id: item.id,
              title: item.name,
              seats: item.max_seats_number,
              bags: item.max_bags_number,
            });
            this.seat_numbers = this.generateSeatsBagsTitles(item.max_seats_number);
            this.baggages_number = this.generateSeatsBagsTitles(item.max_bags_number);
            // if (this.$route.query.show_order_list == "false") {
            this.selectedCar = this.cars[0];
            this.model.vehicle_type_id = this.cars[0].id;

            // }
          });
          if (this.$route.query.show_order_list == "false") {
            this.getBookingfields();
          }
        })
        .catch((err) => console.log(err));
    },
    generateSeatsBagsTitles(num) {
      const titles = [];
      for (let i = 1; i <= num; i++) {
        titles.push({ title: i });
      }
      return titles;
    },
    fixScroll(n, count = 0, changeBy = 1) {
      let target =
        target > scrollLeft
          ? document.getElementById(`${n}`).offsetLeft + 12
          : document.getElementById(`${n}`).offsetLeft - 12;
      // let target = document.getElementById(`${n}`).offsetLeft;
      let scrollLeft = this.$refs.counts.scrollLeft;
      this.$refs.counts.scrollLeft =
        target > scrollLeft ? scrollLeft + changeBy : scrollLeft - changeBy;
      let diff = Math.floor(Math.abs(this.$refs.counts.scrollLeft - target));
      if (count < diff) {
        window.requestAnimationFrame(() => {
          this.fixScroll(n, count + 1, count + 1);
        });
      }
    },
    selectPullDown(event) {
      this.model.pull_down_location = {
        type: "Point",
        coordinates: [event.centroid.coordinates[0], event.centroid.coordinates[1]],
      };
      this.model.city = event;
      this.model.landmark_dropoff = event.title;
    },
    getEstimatedPrice() {
      if (!this.model.pick_up_location.hasOwnProperty("coordinates")) {
        this.pick_up_location_point = null;
      } else {
        this.pick_up_location_point = this.model.pick_up_location;
      }

      let seatsNum = this.model.seats;
      if (this.selectedCar && this.selectedCar.seats > 4)
        seatsNum = 5;
      if (
        this.pick_up_location_point &&
        Object.keys(this.model.pull_down_location).length != 0
      ) {
        this.axios
          .post("estimated_price", {
            pick_up_location: this.pick_up_location_point,
            pull_down_location: this.model.pull_down_location,
            seats: seatsNum,
          })
          .then((res) => {
            this.estimatedPrice = res.data.data ?  res.data.data.min_price  : "";
          });
      }
    },
    selectPickUp(event) {
      this.model.pick_up_location = {
        type: "Point",
        coordinates: [event.geometry.coordinates[0], event.geometry.coordinates[1]],
      };
      this.model.pick_up_location_details = event.formatted_address;
      this.model.landmark_pickup = event.name || event.street_name;
    },
    loadLanguages() {
      axios.get("language").then((res) => {
        this.languages = [];
        console.log(res);
        res.data.data.forEach((item) => {
          this.languages.push({
            title: item.name,
            value: item.id,
            img: `languages/${item.name}.svg`,
          });
        });
      });
    },
    loadPassengerLanguages() {
      this.passenger_languages = [
        { title: this.$t("dispatching.phoneBooking.languages.english"), value: "en", img: "languages/English.svg" },
        { title: this.$t("dispatching.phoneBooking.languages.french"), value: "fr", img: "languages/French.svg" },
        { title: this.$t("dispatching.phoneBooking.languages.italian"), value: "it", img: "languages/Italian.svg" },
      ];

    },
    sendCreateBookingReq() {
      this.formData();
      modelSchema
        .validate(this.model)
        .then(() => {
          this.sendingRequest = true;
          this.axios
            .post("booking", this.model)
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.successfullySaved"), "green");
              this.resetModel();
              window.scrollTo(0, 0);
              if (this.$route.query.phoneNumber) setTimeout(() => window.close(), 1000);
              if (this.closeAfterSubmit) {
                console.log("close window");
              }

              if (this.$route.query.show_order_list === "false") window.close();
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
            })
            .finally(() => {
              this.estimatedPrice = "";
              this.sendingRequest = false;
            });
        })
        .catch(() => {
          window.scrollTo(0, 0);
          Object.keys(this.model).forEach((key) => {
            if (key in this.modelErrors) {
              modelSchema
                .validateAt(key, this.model)
                .then(() => {
                  this.modelErrors[key] = false;
                })
                .catch(() => {
                  console.log("VALIDATION ERROR AT ", key);
                  this.modelErrors[key] = true;
                });
            }
          });
        });
    },
    resetModel() {
      this.selectedCar = this.cars[0];
      this.$refs.passengersAutoComplete.resetResults();
      this.redispatch_van_orders = false;
      (this.model = {
        service_id: 1,
        passenger_id: "",
        passenger_name: "",
        passenger_number: "",
        pick_up_location: {},
        pull_down_location: {},
        pick_up_location_details: "",
        pull_down_location_details: "",
        no_whatsapp: 0,
        vip: 0,
        passenger_language: 'fr',
        city: {},
        number_of_baggages: 1,
        seats: 1,
        pets: false,
        low_car: false,
        phone_booking: true,
        landmark_pickup: null,
        landmark_dropoff: null,
        wheelchair: false,
        round_trip: false,
        vehicle_type_id: this.cars[0].id,
        time: "ASAP",
        languages: [],
        notes: "",
        landmark: "",
        encompt: false,
        amex: false,
        mad: false,
        test: false,
        dynamic_constraints: [],
      }),
        (this.selectedTime = "ASAP");
      this.showMultipleOrdersInput = false;
      this.selectedConstraints = [];
      this.pickUpLocationObj = {};
      this.pulldownLocationObj = {};
    },
    loadConstraints() {
      axios
        .get("dynamic_constraints")
        .then((res) => {
          this.constraints = [];
          this.constraints.push({
            title: "encompt",
            value: "encompt",
            img: "constraints/en_compt.svg",
          });
          res.data.data.data.forEach((item) => {
            if (item.constraint_name == "pets") {
              this.constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/animal.svg",
                strike_through: item.strike_through
              });
            } else if (item.constraint_name == "wheelchair") {
              this.constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/wheelchair.svg",
                strike_through: item.strike_through
              });
            } else if (item.constraint_name == "amex") {
              this.constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/amex.svg",
                strike_through: item.strike_through
              });
            } else if (item.constraint_name == "low_car") {
              this.constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/low_car.svg",
                strike_through: item.strike_through
              });
            } else if (item.constraint_name == "mad") {
              this.constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/mad.svg",
                strike_through: item.strike_through
              });
            } else {
              this.constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: false,
                strike_through: item.strike_through
              });
            }
            console.log("constraints");
            console.log(this.constraints);
          });
        })
        .catch((err) => {
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.phoneBooking.constraintsNotLoaded"), "red");
          }
        });
    },
    getBookingfields() {
      console.log("query1");
      console.log(this.$route.query.id);
      var id = this.$route.query.id;
      console.log(id);
      axios
        .get(`booking/${id}`)
        .then((res) => {
          console.log("BOOKING data");
          console.log(res.data.data);
          console.log(this.constraints);
          console.log("================");
          this.bookingStatus = res.data.data.status;
          // window.getApp.$emit(
          //   "SHOW_TOAST",
          //   `Order #${$route.query.id} has been opend`,
          //   "green"
          // );
          // console.log(res.data.data);
          Object.keys(this.model).forEach((key) => {
            this.model[key] = res.data.data[key] || this.model[key];
          });
          this.selectedCar = this.cars.filter(
            (car) => car.id === this.model.vehicle_type_id
          )[0];
          this.pickUpLocationObj = {
            formatted_address: res.data.data.pick_up_location_details,
          };

          this.model.passenger_number = res.data.data.passenger.phone_number;
          console.log(this.model.passenger_number);
          this.model.passenger_name = res.data.data.passenger.full_name;
          console.log("isNow");
          console.log(res.data.data.now);
          if (!res.data.data.now) {
            this.selectedTime = moment(res.data.data.datetime).format(
              "dddd, MMM DD, Y [at] HH:mm"
            );
            this.model.time = this.selectedTime;
          }


          this.pulldownLocationObj = {
            title: res.data.data.landmark_dropoff,
            formatted_address: null,
          };

          this.$nextTick(() => {
            if (this.pulldownLocationObj.title === "Monaco")
              this.pulldownLocationObj["formatted_address"] =
                res.data.data.pull_down_location_details;
          });

          this.showMultipleOrdersInput = null;
          this.multipleOrdersCount = null;

          // this.model.pull_down_location_details =
          //   res.data.data.pull_down_location_details;
          this.model.notes = res.data.data.notes || "";
          this.model.high_priority = res.data.data.meta.high_priority;
          this.initmodel.high_priority = res.data.data.meta.high_priority;

          var languages = [];
          Object.entries(res.data.data.languages).forEach(([key, value]) => {
            languages[key] = value.language_id;
          });
          this.model.languages = languages;
          this.initmodel.initLanguages = JSON.parse(JSON.stringify(languages));
          // this.initLanguages = languages.slice();
          if (res.data.data.dynamic_constraints.length > 0) {
            res.data.data.dynamic_constraints.forEach((constraint) => {
              this.selectedConstraints.push(constraint.id);
              this.initConstraints.push(constraint.id);
            });
            if (res.data.data.encompt) {
              this.selectedConstraints.push("encompt");
              this.initConstraints.push("encompt");
            }
          }
          this.initmodel.dynamic_constraints = this.initConstraints;

          // this.constraints
          //   .map((e) => e.value)
          //   .forEach((constraint) => {
          //     if (res.data.data.dynamic_constraint)
          //       this.selectedConstraints.push(constraint);
          //   });

          console.log(res.data.data.pull_down_location_details);
          console.log(this.selectedCar);
          console.log("query2");
          console.log(this.model);
          console.log("successfully");

          Object.entries(this.model).forEach(([key, value]) => {
            if (key == "high_priority") {
              console.log("high_priority");
              console.log(value);
            } else {
              console.log("testtesttest");
              console.log(key, value);
              if (key != "dynamic_constraints") this.initmodel[key] = value;
            }
          });
          console.log("initmodel init");
          console.log(this.initmodel);
        })
        .catch((err) => {
          // window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          console.log(err);
        });

      // axios
      //   .get(`getBookingData/${id}`)
      //   .then((res) => {
      //     this.model.high_priority = res.data.data.meta.high_priority;
      //     this.initmodel.high_priority = res.data.data.meta.high_priority;

      //     // res.data.data.languages.forEach((element) => {
      //     //   console.log(element);
      //     // });
      //     this.model.languages = res.data.data.languages;
      //     this.initmodel.languages = res.data.data.languages;
      //   })
      //   .catch((err) => {
      //     console.log('err');
      //     console.log(err);
      //   });
    },
    formData() {
      this.model.dynamic_constraints = this.selectedConstraints;
      this.model.landmark = this.model.landmark_pickup;

      //if (this.model["languages"].length < 1) {
      this.model["languages"] = this.languages.map((item) => item.value);
      //}

      if (this.redispatch_van_orders) {
        this.model["redispatch_van_orders"] = true;
      } else {
        delete this.model["redispatch_van_orders"];
      }

      if (this.showMultipleOrdersInput && parseInt(this.multipleOrdersCount) > 1) {
        this.model["number_of_cars"] = this.multipleOrdersCount;
      }

      if (!this.model.passenger_id) {
        delete this.model.passenger_id;
      }

      if (this.selectedTime !== "ASAP") {
        if (moment(this.selectedTime, 'dddd, MMM DD, Y [at] HH:mm', true).isValid()) {
          this.model["time"] = moment(this.selectedTime, "dddd, MMM DD, Y [at] HH:mm").format("Y-MM-DD HH:mm");
        } else {
          this.model["time"] = moment(this.selectedTime, "DD-MM-YYYY HH:mm").format("Y-MM-DD HH:mm");
        }


      }
      else delete this.model.time;
    },
    validateAt(keys) {
      keys.forEach((key) => {
        if (key in this.modelErrors) {
          modelSchema
            .validateAt(key, this.model)
            .then(() => {
              this.modelErrors[key] = false;
            })
            .catch(() => {
              this.modelErrors[key] = true;
            });
        }
      });
    },
    getShortcutName(status) {
      switch (status) {
        case "IN_STATION":
          return "ST";
        case "IN_SERVICE":
          return "SV";
        case "FREE":
          return "LI";
        case "AT_DESTINATION":
          return "DE";
        case "BUSY":
          return "OC";
      }
    },
    loadStatusesCounts() {
      this.items = [];
      axios.get("statuses-counts").then((res) => {
        res.data.data.forEach((item) => {
          let index = this.items.findIndex((obj) => {
            return obj.title === this.getShortcutName(item.status);
          });
          if (index >= 0) {
            this.items[index].vehicleCounts.push({
              name: item.name.charAt(0).toUpperCase() + item.name.slice(1),
              count: item.count,
            });
          } else {
            this.items.push({
              title: this.getShortcutName(item.status),
              count: item.status_count,
              vehicleCounts: [
                {
                  name: item.name.charAt(0).toUpperCase() + item.name.slice(1),
                  count: item.count,
                },
              ],
            });
          }
        });
      });
    },
    formatPhoneNumber(phoneNumber) {
      if (phoneNumber.substring(0, 2) === "00") {
        return "+" + phoneNumber.substring(2);
      } else if (phoneNumber.substring(0, 1) !== "+") {
        return "+" + phoneNumber.replace(/\s+/g, "");
      }
      return phoneNumber;
    },
    insertDataFrom3cx(value) {
      var number = this.formatPhoneNumber(value);
      this.closeAfterSubmit = true;
      axios
        .get("passenger_numbers", {
          params: {
            search: number,
          },
        })
        .then((res) => {
          console.log("results search params:");
          if (res.data.data.length > 0) {
            this.model.passenger_number = res.data.data[0].username;
            this.model.passenger_name = res.data.data[0].full_name;
            this.model.passenger_id = res.data.data[0].id;
            this.$refs.passengersAutoComplete.checkOrdersWithinThirtyMinutes(
              this.model.passenger_number
            );
          } else {
            this.model.passenger_number = number;
          }
        })
        .catch((err) => console.log(err));
    },
  },

  mounted() {
    if (this.$route.query.edit == 1) {
      this.pageType = "Edit Order";
      this.numberDisabled = true;
    }

    // console.log("HERE IS THE PARAMS");
    // console.log(this.$route.query.data);
    // history.pushState({}, null, this.$route.path);
    this.loadClusters();
    this.loadVehicleTypes();
    this.loadLanguages();
    this.loadPassengerLanguages();
    this.loadConstraints();
    this.loadStatusesCounts();
    if (this.$route.query.phoneNumber) {
      this.insertDataFrom3cx(this.$route.query.phoneNumber);
      console.log("route params 3cx");
      console.log(this.$route.query.phoneNumber);
      //
    }
  },
  watch: {
    // rebuild the translated language titles when the UI language changes
    "$i18n.locale"() {
      this.loadPassengerLanguages();
    },
    'model.vip'(val) {
      this.model.high_priority = val;
    },
     declined_order_dialog: function (val) {
      this.declined_order_loading = false;
      if (val)
        this.declined_form_key++;
      else
        this.declined_city = null;


    },
    selectedCar(newVal) {
      if (typeof newVal !== "undefined" && newVal !== null) {
        this.seat_numbers = this.generateSeatsBagsTitles(newVal.seats);
        this.baggages_number = this.generateSeatsBagsTitles(newVal.bags);
        this.model.seats = 1;
        this.model.number_of_baggages = 1;
        this.getEstimatedPrice();
      }
    },
    selectedConstraints(newVal) {
      this.model.dynamic_constraints = newVal;
      // if(this.arraysEqual(this.initConstraints, newVal) && this.modifiedModel.dynamic_constraints != null)
      //   delete this.modifiedModel.dynamic_constraints;
      // else if(!this.arraysEqual(this.initConstraints, newVal))
      //   this.modifiedModel.dynamic_constraints = newVal;

      // console.log();
      // this.constraints
      //   .map((e) => e.value)
      //   .forEach((item) => {
      //     this.model[item] = false;
      //   });
      // newVal.forEach((item) => {
      //   console.log('selectedConstraints changer');
      //     console.log(item);
      //   this.model[item] = true;
      // });
    },
    initmodel: {
      handler(newModel, oldValue) {
        console.log("watcher languages");
        console.log(newModel);
      },
      deep: true,
    },
    model: {
      handler: function (newModel) {
        if (!this.model.passenger_id) {
          this.model.passenger_language = 'fr';
          this.model.no_whatsapp = 0;
          this.model.vip = 0;
        }
        console.log("VAN, v id");
        console.log(this.model.vehicle_type_id);
        const object = {};
        Object.entries(newModel).forEach(([key, value]) => {
          if (key == "dynamic_constraints") {
            console.log(
              "dynamic_constraints init: " + this.initmodel.dynamic_constraints
            );
            console.log("dynamic_constraints modi: " + value);
          }

          if (
            value != this.initmodel[key] &&
            key != "dynamic_constraints" &&
            key != "time"
          )
            object[key] = value;
          else if (key == "time" && value != this.initmodel[key]) {
            console.log("time ==" + value);
            object[key] = value;
          }

          else if (
            key == "languages" &&
            !this.arraysEqual(this.initmodel.initLanguages, value)
          )
            object["languages"] = value;
          else if (
            key == "dynamic_constraints" &&
            !this.arraysEqual(this.initmodel.dynamic_constraints, value)
          )
            object["dynamic_constraints"] = value;
        });
        console.log("ModifiedBefore");
        console.log(this.modifiedModel);
        // console.log(object);
        this.modifiedModel = object;
        console.log("ModifiedAfter");
        console.log(this.modifiedModel);
        console.log(newModel);
      },
      deep: true,
    },
    selectedTime(value) {
      // console.log('time watcher: ');
      // console.log(value);
      if (value == "ASAP") this.model.time = moment().format("DD-MM-YYYY HH:mm");
      // this.model.time = moment(value).format( "dddd, MMM DD, Y [at] HH:mm A");
      else this.model.time = value;
      // console.log(this.model.time);
      // else
      // console.log('valueValue');
      // console.log(value);
      // console.log(this.initmodel['time']);
      // if (value != this.initmodel['time'] && value !== "ASAP"){
      // this.modifiedModel.time = moment(value).format("Y-MM-DD HH:mm");
      // }
      // else if(value != this.initmodel['time'])
      // this.modifiedModel.time = moment().format("Y-MM-DD HH:mm");
      //  console.log(this.modifiedModel);

      // if (value !== "ASAP" && this.model.time !== value)
      //     this.modifiedModel["time"] = moment(value).format("Y-MM-DD HH:mm");
      // else if(this.model.time == value)
      //     delete this.modifiedModel.time;
    },
    "model.pick_up_location": function (newVal) {
      this.getEstimatedPrice();
    },
    // "model.pull_down_location": function (newVal) {
    //   this.getEstimatedPrice();
    // },
    // "model.seats": function (newVal) {
    //   this.getEstimatedPrice();
    // },
  },
  // components: {
  // ChooseClientPhone,
  // ChooseRadioNewOrder,
  // ChooseCheckBoxGroup,
  // ChooseTimeNewOrder,
  // ChooseAreas,
  // },
  // data() {
  //   return {
  //     drawer: null,
  //     loading: false,
  //     destination_items: [],
  //     cars: [],
  //     flag: true,
  //     constraints: [],
  //     selectedConstraints: [],
  //     validForm: true,
  //     selectedTime: "",
  //     seat_numbers: [
  //       { title: 1 },
  //       { title: 2 },
  //       { title: 3 },
  //       { title: 4 },
  //       { title: 5 },
  //       { title: 6 },
  //       { title: 7 },
  //     ],
  //     baggages_numbrer: [
  //       { title: 1 },
  //       { title: 2 },
  //       { title: 3 },
  //       { title: 4 },
  //       { title: 5 },
  //       { title: 6 },
  //       { title: 7 },
  //     ],
  //     langs: [],
  //     //
  // model: {
  //   service_id: 0,
  //   passenger: "",
  //   passenger_name: "",
  //   passenger_number: "",
  //   select_pick_up_location: "",
  //   select_pull_down_location: "",
  //   pick_up_location: {},
  //   pull_down_location: {},
  //   city: {},
  //   pick_up_location_details: "",
  //   pull_down_location_details: "",
  //   number_of_baggages: 0,
  //   seats: 0,
  //   pets: false,
  //   low_car: false,
  //   phone_booking: true,
  //   landmark_pickup: null,
  //   landmark_dropoff: null,
  //   wheelchair: false,
  //   round_trip: false,
  //   vehicle_type_id: null,
  //   time: "ASAP",
  //   languages: [],
  //   notes: "",
  //   landmark: "",
  //   encompt: false,
  //   amex: false,
  //   mad: false,
  //   test: false,
  // },
  // requiredField: [
  //   "passenger",
  //   "passenger_name",
  //   "passenger_number",
  //   "select_pick_up_location",
  //   "select_pull_down_location",
  //   "pull_down_location",
  //   "seats",
  //   "number_of_baggages",
  //   "vehicle_type_id",
  // ],
  //     errors: {
  //       passenger: false,
  //       passenger_name: false,
  //       passenger_number: false,
  //       select_pick_up_location: false,
  //       select_pull_down_location: false,
  //       seats: false,
  //       pull_down_location: false,
  //       number_of_baggages: false,
  //       vehicle_type_id: false,
  //     },
  //     selectedCar: "",
  //     selectedCity: {
  //       centroid: {},
  //     },
  //     mandatory_details: false,
  //     selectedCarObj: {},
  //   };
  // },
  // methods: {
  //   openDrawer() {
  //     this.loadLanguages();
  //     this.loadClusters();
  //     this.loadVehicleTypes();
  //     this.loadConstraints();
  //     this.drawer = !this.drawer;
  //   },
  //   formData() {
  //     if (!(typeof this.model.passenger === "object")) {
  //       this.model.passenger_number = this.model.passenger;
  //     } else {
  //       this.model.passenger_number = this.model.passenger.username
  //         ? this.model.passenger.username
  //         : "";
  //     }
  //     this.model.landmark = this.model.landmark_pickup;
  //     this.model.pick_up_location = this.model.select_pick_up_location.centroid;
  //     if (
  //       this.mandatory_details &&
  //       this.model.select_pull_down_location != ""
  //     ) {
  //       this.model.pull_down_location = this.model.select_pull_down_location
  //         .centroid
  //         ? this.model.select_pull_down_location.centroid
  //         : "";
  //     } else if (this.selectedCity.title) {
  //       this.model.pull_down_location = {
  //         type: "Point",
  //         coordinates: [
  //           this.selectedCity.centroid.coordinates[0],
  //           this.selectedCity.centroid.coordinates[1],
  //         ],
  //       };
  //     }
  //     // Forming the object to send within the request body
  //     this.model["passenger_id"] = this.model.passenger.id;
  //     this.model["service_id"] = 1;
  //     this.model["pets"] = !!this.selectedConstraints.includes("pets");
  //     this.model["low_car"] = !!this.selectedConstraints.includes("low_car");
  //     this.model["wheelchair"] =
  //       !!this.selectedConstraints.includes("wheelchair");
  //     this.model["amex"] = !!this.selectedConstraints.includes("amex");
  //     this.model["encompt"] = !!this.selectedConstraints.includes("encompt");
  //     this.model["mad"] = !!this.selectedConstraints.includes("mad");
  //     this.model["test"] = !!this.selectedConstraints.includes("test");
  //     this.model["round_trip"] = false;
  //     this.model["vehicle_type_id"] = this.selectedCarObj.id;
  //     if (this.model["languages"].length < 1) {
  //       this.model["languages"] = this.langs.map((item) => {
  //         return item.value;
  //       });
  //     }

  //     if (this.selectedTime !== "ASAP")
  //       this.model["time"] = moment(this.selectedTime).format("Y-MM-DD HH:mm");
  //     else delete this.model.time;
  //   },
  //   validateForm() {
  //     if (this.flag) {
  //       console.log("pull down location error");
  //       this.errors["pull_down_location"] = true;
  //     }
  //     console.log(this.errors["pull_down_location"]);
  //     console.log(this.model.pull_down_location);
  //     // if (Object.keys(this.model.city).length === 0) {
  //     //   console.log("ASDKJASKFNJAFNOJFANSOFASFFASFASF");
  //     //   this.errors["city"] = true;
  //     // }

  //     Object.keys(this.model).forEach((key) => {
  //       if (this.requiredField.indexOf(key) > -1) {
  //         if (
  //           ((this.model[key] == "select_pick_up_location" ||
  //             this.model[key] == "select_pull_down_location" ||
  //             this.model[key] == "pull_down_location") &&
  //             this.model[key].length > 0) ||
  //           this.model[key]
  //         ) {
  //           this.errors[key] = false;
  //         } else {
  //           this.errors[key] = true;
  //           this.validForm = false;
  //         }
  //       }
  //     });
  //     // Object.keys(this.errors).foreach((key) => {
  //     //   if (errors[key] == false) {
  //     //     this.validForm = false;
  //     //   }
  //     // });
  //   },
  //   resetModel() {
  //     this.drawer = !this.drawer;
  //     this.model = {
  //       service_id: 0,
  //       passenger: "",
  //       passenger_name: "",
  //       passenger_number: "",
  //       select_pick_up_location: "",
  //       select_pull_down_location: "",
  //       pick_up_location: {},
  //       pull_down_location: {},
  //       city: {},
  //       pick_up_location_details: "",
  //       pull_down_location_details: "",
  //       number_of_baggages: null,
  //       seats: null,
  //       pets: false,
  //       low_car: false,
  //       encompt: false,
  //       amex: false,
  //       mad: false,
  //       test: false,

  //       phone_booking: true,
  //       landmark_pickup: null,
  //       landmark_dropoff: null,
  //       wheelchair: false,
  //       round_trip: false,
  //       vehicle_type_id: null,
  //       time: "ASAP",
  //       languages: [],
  //       notes: "",
  //       landmark: "",
  //     };
  //     this.selectedConstraints = [];
  //     this.selectedTime = "ASAP";
  //     this.validForm = true;
  //   },
  //   selectCity(event) {
  //     this.flag = false;
  //     console.log("event");
  //     console.log(event.title);
  //     this.errors["select_pull_down_location"] = false;
  //     // if (event.title !== "Monaco") {
  //     this.requiredField = this.requiredField.filter(function (item) {
  //       return item !== "select_pull_down_location";
  //     });
  //     // } else {
  //     //   if (!this.requiredField.includes("select_pull_down_location")) {
  //     //     this.requiredField.includes("select_pull_down_location");
  //     //   }
  //     // }
  //     this.selectedCity = event;
  //     this.errors["pull_down_location"] = false;
  //     this.mandatory_details = this.selectedCity.title === "Monaco";
  //     this.model.pull_down_location = {
  //       type: "Point",
  //       coordinates: [
  //         event.centroid.coordinates[0],
  //         event.centroid.coordinates[1],
  //       ],
  //     };
  //     this.model.landmark_dropoff = this.selectedCity.title;
  //   },
  //   loadClusters() {
  //     this.axios
  //       .get("location_cluster?perPage=100")
  //       .then((res) => {
  //         this.destination_items = [];
  //         res.data.data.data.forEach((item) => {
  //           this.destination_items.push({
  //             id: item.id,
  //             title: item.title,
  //             centroid: item.centroid,
  //             type: item.type,
  //             far_city: item.far_city ? item.far_city : 0,
  //           });
  //         });
  //       })
  //       .catch((err) => console.log(err));
  //   },
  //   loadConstraints() {
  //     // For translating & dynamic purposes
  //     this.constraints = [
  //       { title: "Animal", img: "constraints/animal.svg", value: "pets" },
  //       {
  //         title: "Fauteil roulant",
  //         img: "constraints/wheelchair.svg",
  //         value: "wheelchair",
  //       },
  //       {
  //         title: "low car",
  //         img: "constraints/low_car.svg",
  //         value: "low_car",
  //       },
  //       {
  //         title: "amex",
  //         img: "constraints/amex.svg",
  //         value: "amex",
  //       },
  //       {
  //         title: "encompt",
  //         img: "constraints/en_compt.svg",
  //         value: "encompt",
  //       },
  //       {
  //         title: "mad",
  //         img: "constraints/mad.svg",
  //         value: "mad",
  //       },
  //       {
  //         title: "test",
  //         img: "constraints/test.svg",
  //         value: "test",
  //       },
  //     ];
  //   },
  //   loadLanguages() {
  //     // For translating & dynamic purposes
  //     this.axios
  //       .get("language")
  //       .then((res) => {
  //         this.langs = [];
  //         res.data.data.forEach((lang) => {
  //           this.langs.push({
  //             title: lang.name,
  //             img: `languages/${lang.name}.svg`,
  //             value: lang.id,
  //           });
  //         });
  //       })
  //       .catch((err) => {
  //         this.$notify({
  //           title: "Error",
  //           text: err.response.data.message || err.message,
  //           type: "error",
  //         });
  //       });
  //   },
  //   selectVehicleType(event) {
  //     this.errors["vehicle_type_id"] = false;
  //     this.selectedCarObj = event;
  //     this.seat_numbers = [];
  //     for (var i = 1; i <= this.selectedCarObj.seats; i++) {
  //       this.seat_numbers.push({
  //         title: i,
  //       });
  //       this.model.seats = 1;
  //       this.model.number_of_baggages = 1;
  //     }
  //     console.log(this.seat_numbers);
  //   },
  // },
  computed: {
    required() {
      return (val) => !!val || this.$t("common.required");
    },
  },
  // watch: {
  //   "model.select_pick_up_location": function (newVal) {
  //     this.model.pick_up_location_details =
  //       (newVal.name ? newVal.name + ", " : "") +
  //       (newVal.street_number ? newVal.street_number + " " : "") +
  //       (newVal.street_name ? newVal.street_name : "");
  //     this.model.landmark_pickup = newVal.name
  //       ? newVal.name
  //       : newVal.street_name;
  //   },
  //   "model.select_pull_down_location": function (newVal) {
  //     this.model.pull_down_location_details =
  //       (newVal.name ? newVal.name + ", " : "") +
  //       (newVal.street_number ? newVal.street_number + " " : "") +
  //       (newVal.street_name ? newVal.street_name : "");
  //     this.model.landmark_dropoff = newVal.name
  //       ? newVal.name
  //       : newVal.street_name;
  //   },
  //   selectedTime: function (newVal) {
  //     if (this.selectedTime != "ASAP") {
  //       this.selectedCity = null;
  //       this.mandatory_details = false;
  //       this.destination_items = this.destination_items.filter((item) => {
  //         return item.far_city > 0;
  //       });
  //     } else {
  //       this.loadClusters();
  //     }
  //   },
  // },
};
</script>
<style lang="scss" scoped>
.location-card {
  border-radius: 14px !important;
  overflow: hidden;
  font-family: "Poppins", sans-serif !important;

  p,
  span,
  div,
  button {
    font-family: inherit;
  }
}

.location-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #eceef4;

  .location-title {
    margin: 0 !important;
    font-size: 20px;
    font-weight: 600;
    color: #202731;
    line-height: 1.3;
  }

  .location-subtitle {
    margin: 2px 0 0 !important;
    font-size: 14px;
    color: #788e98;
  }

  .location-close-icon {
    width: auto;
    max-width: none;
    float: none;
    margin: 0;
    padding: 4px 8px;
    background: none;
    color: #788e98;
    font-size: 18px;
    line-height: 1;
    border-radius: 8px;
    transition: 0.15s;

    &:hover {
      background-color: #f7f8fa;
      color: #202731;
    }
  }
}

.location-content {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 20px;
  padding: 20px 24px;
}

.location-map {
  flex: 1 1 55%;
  min-width: 280px;
  height: 450px;
  border: 1px solid #eceef4;
  border-radius: 12px;
  overflow: hidden;
}

.landmarks {
  flex: 1 1 38%;
  min-width: 280px;
  max-height: 500px;
  overflow-y: auto;
  padding-right: 4px;

  .landmarks-title {
    margin: 0 0 10px !important;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #788e98;
  }

  .landmark {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    margin-bottom: 10px;
    background-color: #f7f8fa;
    border: 1px solid transparent;
    border-radius: 12px;
    cursor: pointer;
    user-select: none;
    transition: 0.15s;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background-color: #ffffff;
      border-color: #c1c5d8;
      box-shadow: 0 2px 8px rgba(0, 11, 138, 0.08);

      .landmark-hint {
        opacity: 1;
      }
    }

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    &.loading {
      opacity: 1;
      border-color: #1976d2;
    }

    .landmark-info {
      display: flex;
      flex-direction: column;
      min-width: 0;
    }

    .landmark-name {
      font-size: 15px;
      font-weight: 600;
      color: #202731;
    }

    .landmark-address {
      margin-top: 2px;
      font-size: 13px;
      color: #788e98;
    }

    .landmark-hint {
      flex-shrink: 0;
      padding: 6px 12px;
      background-color: rgba(25, 118, 210, 0.1);
      border-radius: 999px;
      font-size: 12px;
      font-weight: 600;
      color: #1976d2;
      white-space: nowrap;
      opacity: 0.75;
      transition: 0.15s;
    }
  }

  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c5d8;
    border-radius: 9999px;
  }
}

.location-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0 24px 20px;

  .location-close {
    width: auto;
    max-width: none;
    float: none;
    margin: 0;
    padding: 10px 24px;
    background-color: #f7f8fa;
    border: 1px solid #c1c5d8;
    border-radius: 8px;
    color: #202731;
    font-size: 14px;
    transition: 0.15s;

    &:hover {
      background-color: #eceef4;
    }
  }
}

input {
  width: 100%;
  max-width: 400px;
  padding: 16px 15px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c1c5d8;
  background-color: #f7f8fa;
  float: left;
  color: #202731;
}

input:focus {
  border-color: #202731;
  outline: none;
}

form {
  span {
    width: 100%;
    float: left;
    max-width: 400px;
    text-align: left;
    color: #e10015;
    font-size: 14px;
    padding-bottom: 2px;
  }
}

input::placeholder {
  color: #788e98;
  opacity: 1;
  /* Firefox */
}

input::-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #788e98;
}

input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #788e98;
}

button {
  width: 100%;
  max-width: 160px;
  float: right;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #e10015;
  color: white;
  font-size: 14px;
  border-radius: 4px;
  transition: 0.1s;
  margin-top: 48px;
}

button:active {
  transform: scale(0.98);
}

.shadow {
  box-shadow: 0 0 6px rgba(0, 11, 138, 0.12) !important;
}

.input {
  label:first-child {
    text-align: left;
    float: left;
    font-size: 14px;
    padding-bottom: 6px;
    width: 100%;
    color: #788e98;

    span {
      float: right;
      text-align: right;
      color: red;
    }
  }

  input {
    float: left;
    width: 100%;
    max-width: none;
  }

  .check-box {
    float: left;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    input {
      width: 14px;
      height: 14px;
      float: left;
    }

    label {
      margin-left: 4px;
    }
  }
}

.main-container {
  float: left;
  width: 100%;
  padding: 2rem 9rem;
  display: flex;
  justify-content: center;
  align-items: center;

  .elements-container {
    display: flex;
    float: left;
    flex-direction: row;
    width: 100%;
    gap: 3.5rem;

    .order-form {
      float: left;
      padding-top: 2.25rem;
      padding-bottom: 2.25rem;
      padding-left: 2.5rem;
      padding-right: 2.5rem;
      flex-grow: 1;
      width: 60%;
      border-radius: 0.5rem;

      .form {
        display: flex;
        float: left;
        flex-direction: column;
        width: 100%;
        gap: 1.5rem;

        div {
          width: 100%;
          float: left;

          &:first-child {
            h1 {
              color: #202731;
              font-size: 1.125rem;
              line-height: 1.75rem;
              font-weight: 500;
              text-align: left;
            }

            h2 {
              font-weight: 400 !important;
              font-size: 1rem;
              line-height: 1.25rem;
              text-align: left;
              color: #788e98;
            }
          }
        }
      }
    }
  }
}

.text-red {
  color: red !important;
}

.border-red {
  border: 1px solid red !important;
}

// bg-white
// shadow
// rounded-lg
// flex-grow
// h-auto
// pt-6
// pb-0
// px-4
// sticky
// top-8

.right-bar {
  width: 400px;
  position: sticky;
  top: 92px;
  height: calc(100vh - 120px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  gap: 1.5rem;
  padding-bottom: 1.5rem;

  .client-orders {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 0;
    padding-top: 1.5rem;
    background-color: #ffffff;
    height: auto;
    flex-grow: 1;
    flex-shrink: 1;
    border-radius: 0.5rem;
    float: left;
  }

  .drivers-count {
    width: 100%;
    padding: 1rem;
    background: #fff;
    height: 12.5rem;
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    border-radius: 0.5rem;
    float: left;
    overflow-x: overlay;
    gap: 12px;
    position: relative;

    .message {
      width: 100%;
      height: 100%;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;
      color: red;
      position: absolute;
      top: 0;
      left: 0;
    }

    &::-webkit-scrollbar {
      height: 0px;
    }

    .item {
      height: 100%;
      border-radius: 0.5rem;
      position: relative;
      background: white;
      float: left;
      width: 70px;
      overflow: hidden;
      cursor: pointer;
      transition: 0.4s;
      flex-grow: 0;
      flex-shrink: 0;

      &.zero-width {
        width: 0px;
      }

      &.hidden {
        display: none;
      }

      &:hover {
        width: 230px;

        .item-container {
          .item-content:first-child {
            background-color: #f3f3f3;
          }
        }
      }

      .vehicle-counts {
        float: left;
        height: 100%;
        padding: 6px;
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: 33.3% 33.3% 33.3%;
        width: 160px;
        cursor: default;
        background: white;

        div {
          padding: 4px;
          overflow: hidden;
          width: 100%;

          label:first-child {
            font-weight: 600;
          }

          label {
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .item-container {
        position: absolute;
        left: 0;
        top: 0;
        float: left;
        display: flex;
        justify-content: flex-start;
        height: 100%;

        .item-content {
          float: left;
          height: 100%;
          padding: 24px;
          width: 70px;
          text-align: center;
          background: white;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
          flex-direction: column;
          transition: 0.2s;

          h2 {
            font-size: 12pt;
            line-height: 16pt;
            max-width: 100%;
            // word-break: break-word;
          }

          label {
            font-size: 18pt;
            line-height: 24pt;
            max-width: 100%;
          }
        }
      }
    }
  }
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
            supported by Chrome, Edge, Opera and Firefox */
}

.pass-container {
  display: flex;
}

.pass-left,
.pass-right {
  flex: 1;
  padding: 10px;
}
</style>
